import React, {Component} from 'react'

class Options extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		}
	}

	// 셀렉트 박스 내 옵션 하위 요소 토글
	toggleDepth = (data, event) => {
		event.preventDefault();
		
		this.setState(prevOpen => ({
			isOpen: !prevOpen.isOpen
		}), () => {
			this.props.SelectEvent(data)
		})
	}

	// 옵션 선택시 이벤트
	selectItem = (data, event) => {
		event.preventDefault();
		
		this.props.SelectEvent(data)
	}

	render() {
		return (
			this.props.children ?
				<div className={`form-tree-item ${this.state.isOpen ? "active" : ""}`}>
					<button
						type="button"
						className="btn-tree-nav"
						onClick={(e) => this.toggleDepth(this.props.data, e)}
						name={this.props.inputName}
						value={this.props.value}>
						{this.props.name}
					</button>
					{this.state.isOpen && (
						<div className="detail-tree-item">
							{this.props.children.map((data, idx) => {
								return (
									<Options
										key={idx}
										data={data}
										name={data.name}
										inputName={this.props.inputName}
										value={data.value}
										children={data.children && data.children}
										SelectEvent={this.props.SelectEvent}
									/>
								)
							})}
						</div>
					)}
				</div>
				:
				<div>
					<button
						type="button"
						className="btn-select-list"
						name={this.props.inputName}
						value={this.props.value}
						onClick={(e) => this.selectItem(this.props.data, e)}>
						{this.props.name}
					</button>
				</div>
		)
	}
}

export default Options;
